import {
  EnvironmentProviders,
  ErrorHandler,
  Signal,
  computed,
  effect,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { CurrentUser } from '@app/shared/auth';
import { KobitoUser } from '@app/shared/user';
import * as Sentry from '@sentry/angular';

export function setupSentry(config: Sentry.BrowserOptions) {
  Sentry.init({
    integrations: [Sentry.browserTracingIntegration()],
    ...config,
  });
}

/**
 * Sentry に Kobito のユーザー情報をバインドする。
 * ログインユーザーが変更されるたびに、Sentry.setUser() を呼び出す。
 */
export function bindKobitoUserToSentry(
  $currentUser: Signal<KobitoUser | null>,
) {
  effect(() => {
    const user = $currentUser();
    if (user === null) {
      Sentry.getCurrentScope().setUser(null);
    } else {
      Sentry.getCurrentScope().setUser({
        id: user.id,
        username: user.displayName,
        email: user.email,
      });
    }
  });
}

/**
 * Sentry と連携するサービスクラスを提供する。
 */
export function provideSentryAdapter(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({}),
    },
    provideAppInitializer(() => {
      const currentUser = inject(CurrentUser);
      bindKobitoUserToSentry(computed(() => currentUser.get()));
    }),
  ]);
}
